import { useSeoMenu } from './use-seo-menu';

export function SeoMenu({ children }: { children: JSX.Element }): JSX.Element {
  useSeoMenu();

  return children;
}
